<template lang="html">
  <section class="actionsheet-wrapper">
    <transition name="actionsheet-mask">
      <div class="mask mask-transparent" @click="hide" v-show="isShow"></div>
    </transition>
    <div class="actionsheet" :class="{ 'actionsheet-toggle': isShow }">
      <actionTitle
        :title="actionHeader.title"
        :needArrow="actionHeader.needArrow"
        :callback="callback"
      ></actionTitle>
      <div
        class="actionsheet-bd"
        :class="{
          hideTitle: actionHeader.title === '',
          'body-show': viewName === 'specification'
        }"
      >
        <component
          :is="viewName"
          :params="params"
          :callback="callback"
        ></component>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import cancelReason from '@/components/order/cancelReason'
import cancelReasonUseInList from '@/components/order/cancelReasonUseInList'
import refundReason from '@/components/order/refundReason'
import workers from '@/components/work'
import confirmAddress from '@/components/confirm/selectAddress'
// import fillInCityForm from '@/components/collect/support-city'
import fillInStoreForm from '@/components/collect/support-store'
import serveExplain from './labels-sheet'
import recoveryServeExplain from './recoveryServeExplain'
import calendar from './date-sheet'
import actionTitle from './actionTitle'
import addressSheet from './address-sheet'
import areaSelect from './area-sheet'
import specification from './product-type'
import enteringAreaSelect from '../entering/entering-area-sheet'
import enteringAddressSelect from '../entering/entering-address-sheet'
import storeSheet from './store-sheet'
import couponSheet from '../home/couponSheet'
import collectFillInSheet from '../collect/collect-fillIn-sheet'

export default {
  props: {
    viewName: {
      type: String
    },
    callback: {
      // 点击浮层关闭回调
      type: Function
    },
    params: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    isShow(val) {
      if (val) {
        this.scrollTop = document.body.scrollTop
        // setTimeout(() => {
        document.body.scrollTop = 0
        document.body.classList.add('of-hide')
        document.documentElement.classList.add('of-hide')
        // }, 600)
      } else {
        document.body.classList.remove('of-hide')
        document.documentElement.classList.remove('of-hide')
        document.body.scrollTop = this.scrollTop
      }
    }
  },
  mounted() {
    const actionsheet = document.querySelector('.actionsheet')
    if (actionsheet) {
      actionsheet.addEventListener('transitionend', () => {
        if (!this.isShow) {
          this.changeView('')
        }
      })
    }
    if (this.viewName === 'storeSheet') {
      this.showActionSheet()
    }
    // const container = document.querySelector('.actionsheet-bd')
    // if (container) {
    //     container.addEventListener('scroll', (e) => {
    //         e.preventDefault()
    //     })
    //     container.addEventListener('touchmove', (e) => {
    //         e.preventDefault()
    //     })
    // }
  },
  computed: {
    ...mapState({
      isShow: 'isActionSheetShow',
      actionHeader: 'actionHeader'
    })
  },
  methods: {
    ...mapMutations(['hideActionSheet', 'changeView', 'showActionSheet']),
    hide() {
      this.hideActionSheet()
      if (this.callback) {
        this.callback()
      }
      if (this.viewName === 'serveExplain') {
        this.$$tracker('100101', '20000', 21013)
      } else if (this.viewName === 'addressSheet') {
        this.$$tracker('100101', '20000', 21021)
      } else if (this.viewName === 'workers') {
        this.$$tracker('100101', '20000', 21023)
      } else if (this.viewName === 'calendar') {
        this.$$tracker('100101', '20000', 21027)
      } else if (this.viewName === 'cancelReason') {
        this.$$tracker('110501', '20000', 21051)
      } else if (this.viewName === 'collectFillInSheet') {
        this.$$tracker('210101', '20000', 21248)
      }
    }
  },
  components: {
    cancelReason,
    cancelReasonUseInList,
    serveExplain,
    actionTitle,
    calendar,
    workers,
    addressSheet,
    areaSelect,
    confirmAddress,
    refundReason,
    specification,
    enteringAreaSelect,
    enteringAddressSelect,
    storeSheet,
    couponSheet,
    collectFillInSheet,
    // fillInCityForm,
    fillInStoreForm,
    recoveryServeExplain
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/css/mixin';

.mask,
.mask-transparent {
  position: fixed;
  z-index: 200;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}
.mask {
  background: rgba(0, 0, 0, 0.4);
}
.actionsheet {
  position: fixed;
  left: 0;
  bottom: 0;
  transform: translate(0, 100%);
  backface-visibility: hidden;
  z-index: 210;
  width: 100%;
  height: rem(850px);
  background-color: #fff;
  transition: transform 0.3s;

  .actionsheet-bd {
    position: absolute;
    top: rem(100px);
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
  }
  .body-show {
    overflow: visible;
  }
  .hideTitle {
    top: 0;
  }
}
.actionsheet-toggle {
  transform: translate(0, 0);
}
.actionsheet-mask-enter,
.actionsheet-mask-leave-active {
  opacity: 0;
}
.actionsheet-mask-leave-active,
.actionsheet-mask-enter-active {
  transition: opacity 300ms;
}
</style>
